import { usePaginatedQuery } from '@playbookux/playbook-web-core';
import { TEST_SESSION_LIST } from './graphql';

function useSessions(attributes) {
  return usePaginatedQuery(
    TEST_SESSION_LIST,
    {
      variables: {
        status: 'transcribe_error',
        ...attributes,
      },
      fetchPolicy: 'network-only',
    },
    { dataField: 'testSessionList' },
  );
}

export default useSessions;
